// extracted by mini-css-extract-plugin
module.exports = {"textLink":"bmiV0"};